"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var components_1 = require("@theme-ui/components");
var core_1 = require("@theme-ui/core");
var gatsby_plugin_image_1 = require("gatsby-plugin-image");
var react_1 = require("react");
var helpers_1 = require("../../helpers");
var ImageComponent = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var imageData = _a.imageData, alt = _a.alt, credits = _a.credits, className = _a.className, aspectRatio = _a.aspectRatio, _h = _a.loading, loading = _h === void 0 ? "lazy" : _h;
    var normalizedAspectRatio = 0;
    switch (aspectRatio) {
        case "square":
            normalizedAspectRatio = 1;
            break;
        case "portrait":
            normalizedAspectRatio = 2 / 3;
            break;
        case "landscape":
            normalizedAspectRatio = 16 / 9;
            break;
    }
    var source = null;
    var Img = null;
    if ((_b = imageData === null || imageData === void 0 ? void 0 : imageData.childCloudinaryAsset) === null || _b === void 0 ? void 0 : _b.gatsbyImageData) {
        source = "CLOUDINARY";
    }
    else if ((_d = (_c = imageData === null || imageData === void 0 ? void 0 : imageData.childSvg) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.data) {
        source = "SVG";
    }
    else if (imageData === null || imageData === void 0 ? void 0 : imageData.publicURL) {
        source = "PATH";
    }
    else {
        source = "UNKNOWN";
    }
    switch (source) {
        case "CLOUDINARY": {
            Img = ((_e = imageData === null || imageData === void 0 ? void 0 : imageData.childCloudinaryAsset) === null || _e === void 0 ? void 0 : _e.gatsbyImageData) ? ((0, core_1.jsx)(gatsby_plugin_image_1.GatsbyImage, { image: imageData.childCloudinaryAsset.gatsbyImageData, alt: alt, className: className, loading: loading, sx: {
                    height: normalizedAspectRatio ? "100%" : undefined,
                    width: normalizedAspectRatio ? "100%" : undefined,
                } })) : null;
            break;
        }
        case "SVG": {
            Img = ((_g = (_f = imageData === null || imageData === void 0 ? void 0 : imageData.childSvg) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.data) ? ((0, core_1.jsx)("span", { title: alt, className: className, sx: {
                    display: "block",
                    height: normalizedAspectRatio ? "100%" : undefined,
                    width: normalizedAspectRatio ? "100%" : undefined,
                    "& > svg": {
                        fill: "currentcolor",
                        display: "block",
                        height: "100%",
                        width: "100%",
                    },
                }, dangerouslySetInnerHTML: {
                    __html: imageData.childSvg.content.data,
                } })) : null;
            break;
        }
        case "PATH": {
            Img = (imageData === null || imageData === void 0 ? void 0 : imageData.publicURL) ? ((0, core_1.jsx)(components_1.Image, { src: imageData.publicURL, alt: alt, className: className, sx: {
                    objectFit: "cover",
                    display: "block",
                    height: normalizedAspectRatio ? "100%" : undefined,
                    width: normalizedAspectRatio ? "100%" : undefined,
                }, width: imageData.width || "100%", loading: loading })) : null;
            break;
        }
        case "UNKNOWN": {
            Img = ((0, core_1.jsx)(components_1.Image, { src: imageData, alt: alt, className: className, sx: {
                    objectFit: "cover",
                    display: "block",
                    height: normalizedAspectRatio ? "100%" : undefined,
                    width: normalizedAspectRatio ? "100%" : undefined,
                }, width: (imageData === null || imageData === void 0 ? void 0 : imageData.width) || "100%", loading: loading }));
            break;
        }
    }
    return ((0, core_1.jsx)("span", { sx: {
            display: "block",
            position: "relative",
            height: "100%",
            width: "100%",
        } },
        normalizedAspectRatio ? ((0, core_1.jsx)(components_1.AspectRatio, { ratio: normalizedAspectRatio }, Img)) : (Img),
        credits && ((0, core_1.jsx)("div", { sx: {
                position: "absolute",
                left: 3,
                right: 3,
                bottom: 3,
                color: "#fff",
                textShadow: "1px 1px 0 rgba(0,0,0,.5)",
                fontSize: (0, helpers_1.responsive)({ xs: 0, md: 1 }),
                textAlign: "right",
                lineHeight: 1,
            } }, credits))));
};
exports.default = (0, react_1.memo)(ImageComponent);
